import {BaseWrapper} from '../../framework/parameters/BaseWrapper';
import {BasicCriteria} from '../../framework/parameters/BasicCriteria';
import {BasicScenario} from '../../framework/parameters/BasicScenario';
import {UserTrack} from '../message/UserTrack';

export class UserTrackWrapper extends BaseWrapper<UserTrack, BasicCriteria, BasicScenario>  {}

